export default __webpack_public_path__ + "static/media/bg-performance-2.8df2a349.png";